import { render, staticRenderFns } from "./edit-gallery-settings.vue?vue&type=template&id=64b8f882&scoped=true&"
import script from "./edit-gallery-settings.vue?vue&type=script&lang=ts&"
export * from "./edit-gallery-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8f882",
  null
  
)

export default component.exports